import { Col, Form, Row } from "antd";
import React from "react";
import Explain from "../../../../components/atoms/Explain";
import TimePicker from "../../../../components/atoms/TimePicker";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import sharedConstants from "../../../../shared/constants";
import { theme } from "../../../../theme";
import { RenderInputProps } from "../../Interface";
import { Wave } from "../../styles";
import { stringTimeToMoment } from "../../utils";

const { Item } = Form;
const HolidayReservationInputs: React.FC<RenderInputProps> = ({ form }) => {
  const holidayStartBusinessTime = Form.useWatch(
    ["repairShopBusiness", "holidayStartBusinessTime"],
    form
  );
  const holidayEndBusinessTime = Form.useWatch(
    ["repairShopBusiness", "holidayEndBusinessTime"],
    form
  );
  const repairShopHolidayWorkdays = Form.useWatch(
    ["repairShopBusiness", "repairShopHolidayWorkdays"],
    form
  );

  return (
    <Row style={{ width: "100%" }} gutter={[12, 12]}>
      <Col span={24}>
        <Item
          noStyle
          rules={[
            {
              validator: () => {
                if (!holidayEndBusinessTime || !holidayStartBusinessTime)
                  return Promise.reject(
                    new Error(
                      sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                    )
                  );
                if (
                  stringTimeToMoment(holidayStartBusinessTime)?.isSameOrAfter(
                    stringTimeToMoment(holidayEndBusinessTime)
                  )
                )
                  return Promise.reject(
                    new Error(
                      sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME
                    )
                  );
                return Promise.resolve();
              },
            },
          ]}
          name={["repairShopBusiness", "holidayStartBusinessTime"]}
        />
        <Item
          noStyle
          rules={[
            {
              validator: () => {
                if (!holidayEndBusinessTime || !holidayStartBusinessTime)
                  return Promise.reject(
                    new Error(
                      sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                    )
                  );
                if (
                  stringTimeToMoment(holidayStartBusinessTime)?.isSameOrAfter(
                    stringTimeToMoment(holidayEndBusinessTime)
                  )
                )
                  return Promise.reject(
                    new Error(
                      sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME
                    )
                  );
                return Promise.resolve();
              },
            },
          ]}
          name={["repairShopBusiness", "holidayEndBusinessTime"]}
        />
        <Explain
          color={theme.colors.gray3}
          status="question"
          explain="공휴일 영업시간과 휴게시간은 전체 공휴일에 공통적용 됩니다."
        />
        {repairShopHolidayWorkdays?.length > 0 &&
          ` ${repairShopHolidayWorkdays
            ?.map((val: string) => val)
            .join(", ")}에 적용될 영업시간 입니다.`}
      </Col>
      <Col span={24}>
        <Row gutter={[12, 0]}>
          <Col flex="0 0 200px">
            <ExplainWrapper
              status={{
                status:
                  !holidayEndBusinessTime ||
                  !holidayStartBusinessTime ||
                  stringTimeToMoment(holidayStartBusinessTime)?.isSameOrAfter(
                    stringTimeToMoment(holidayEndBusinessTime)
                  )
                    ? "error"
                    : undefined,
                explain:
                  !holidayEndBusinessTime || !holidayStartBusinessTime
                    ? sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                    : stringTimeToMoment(
                        holidayStartBusinessTime
                      )?.isSameOrAfter(
                        stringTimeToMoment(holidayEndBusinessTime)
                      )
                    ? sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME
                    : undefined,
              }}
            >
              <TimePicker
                popupStyle={{
                  minWidth: "calc(200px - 32px)",
                }}
                onOk={(selectedTime) => {
                  form.setFieldsValue({
                    repairShopBusiness: {
                      holidayStartBusinessTime: selectedTime
                        ? selectedTime.format("HH:mm")
                        : undefined,
                    },
                  });
                }}
                status={
                  !holidayEndBusinessTime ||
                  !holidayStartBusinessTime ||
                  stringTimeToMoment(holidayStartBusinessTime)?.isSameOrAfter(
                    stringTimeToMoment(holidayEndBusinessTime)
                  )
                    ? "error"
                    : undefined
                }
                // disabledTime={() =>
                //   makeDisableStartTime({
                //     endTime: stringTimeToMoment(holidayEndBusinessTime),
                //     startTime: stringTimeToMoment(holidayStartBusinessTime),
                //   })
                // }
                // type={TimeMode.START}
                // endHour={stringTimeToMoment(holidayEndBusinessTime)?.hours()}
                value={stringTimeToMoment(holidayStartBusinessTime)}
              />
            </ExplainWrapper>
          </Col>
          <Wave />
          <Col flex="0 0 200px">
            <TimePicker
              popupStyle={{
                width: "calc(200px - 32px)",
              }}
              onOk={(selectedTime) => {
                form.setFieldsValue({
                  repairShopBusiness: {
                    holidayEndBusinessTime: selectedTime
                      ? selectedTime.format("HH:mm")
                      : undefined,
                  },
                });
              }}
              status={
                !holidayEndBusinessTime ||
                !holidayStartBusinessTime ||
                stringTimeToMoment(holidayStartBusinessTime)?.isSameOrAfter(
                  stringTimeToMoment(holidayEndBusinessTime)
                )
                  ? "error"
                  : undefined
              }
              // disabledTime={() =>
              //   makeDisableEndTime({
              //     endTime: stringTimeToMoment(holidayEndBusinessTime),
              //     startTime: stringTimeToMoment(holidayStartBusinessTime),
              //   })
              // }
              // type={TimeMode.END}
              // startHour={stringTimeToMoment(holidayStartBusinessTime)?.hours()}
              value={stringTimeToMoment(holidayEndBusinessTime)}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default HolidayReservationInputs;
